/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation SenderRoutePlanUpdateMutation($routePlanId: ID, $routePlanIds: [ID!], $input: [SenderRoutePlanUpdateInput!]!) {
  SenderRoutePlanUpdate(routePlanId: $routePlanId, routePlanIds: $routePlanIds, input: $input) {
    id,
    message
    status
  }
}
`
